import { render, staticRenderFns } from "./AddDivCountViewer.vue?vue&type=template&id=023f15fa&scoped=true&"
import script from "./AddDivCountViewer.vue?vue&type=script&lang=ts&"
export * from "./AddDivCountViewer.vue?vue&type=script&lang=ts&"
import style0 from "./AddDivCountViewer.vue?vue&type=style&index=0&id=023f15fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f15fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VRow})
